var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojiLaughing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "esqy1bytob",
    width: "114.6%",
    height: "114.6%",
    x: "-7.3%",
    y: "-7.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 0.76452106 0 0 0 0 0.248180456 0 0 0 0 0.049720091 0 0 0 0.45 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "mfvefrka5a",
    cx: 28.125,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    id: "9zg2ya6ekc",
    d: "M1.575 0c4.5 1.797 9.906 2.695 15.753 2.695 5.847 0 11.697-1.123 16.197-2.695 3.825 7.861-1.575 20.215-16.2 20.215S-2.925 6.963 1.575 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-1191 -603) translate(990 515) translate(199 88) translate(3.875 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFDA46",
    xlinkHref: "#mfvefrka5a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#esqy1bytob)",
    xlinkHref: "#mfvefrka5a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#59391F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M14.146 19.341L22.631 23.319 13.729 25.764",
    transform: "translate(-1191 -603) translate(990 515) translate(199 88) rotate(-20 18.18 22.552)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#59391F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25,
    d: "M30.292 13.073L38.906 17.08 30.003 19.753",
    transform: "translate(-1191 -603) translate(990 515) translate(199 88) scale(-1 1) rotate(20 0 -178.99)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1191 -603) translate(990 515) translate(199 88) rotate(-20 93.693 -18.911)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "2ndzoh4k4d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9zg2ya6ekc"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#471D18",
    xlinkHref: "#9zg2ya6ekc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.375.674h27.9v.717c0 2.207-1.462 4.148-3.584 4.757-3.455.993-6.91 1.489-10.366 1.489-3.455 0-6.91-.496-10.366-1.489-2.122-.609-3.584-2.55-3.584-4.757V.674z",
    mask: "url(#2ndzoh4k4d)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.7,
    height: 16.172,
    x: 7.2,
    y: 10.332,
    fill: "#F13A37",
    mask: "url(#2ndzoh4k4d)",
    rx: 8.086
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#308AFC",
    fillRule: "nonzero",
    d: "M3.282 40.556c-1.814-1.814-1.814-4.755 0-6.569 2.708-2.708 8.391-3.927 10.305-4.272.317-.057.594.22.537.537-.345 1.913-1.565 7.597-4.272 10.304-1.814 1.814-4.756 1.814-6.57 0z",
    transform: "translate(-1191 -603) translate(990 515) translate(199 88) rotate(-20 8.027 35.812)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#308AFC",
    fillRule: "nonzero",
    d: "M55.639 24.306c1.814-1.814 1.814-4.755 0-6.569-2.708-2.707-8.391-3.927-10.304-4.272-.318-.057-.595.22-.537.537.345 1.913 1.564 7.597 4.272 10.304 1.814 1.814 4.755 1.814 6.569 0z",
    transform: "translate(-1191 -603) translate(990 515) translate(199 88) rotate(-20 50.895 19.562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiLaughing);
export default __webpack_public_path__ + "static/media/emoji-laughing.861d12f2.svg";
export { ForwardRef as ReactComponent };